import {
  createContext,
  PropsWithChildren,
  useCallback,
  // useEffect,
  useMemo,
  useState
} from 'react'
import { useKey } from 'react-use'

// import gsap from 'gsap'
import { Modal } from '@/contexts/modal'

// import { useStore } from '@/contexts/store'
import { BannerModal, FormModal } from './components'

export type ModalInstance = {
  slug?: string
  open?: boolean
  reveal?: boolean
}

export type ModalState = {
  form?: ModalInstance
  banner?: ModalInstance
}

export const ModalContext = createContext<
  | {
      // eslint-disable-next-line no-unused-vars
      setPreventModal: (prevent: boolean) => void
      // eslint-disable-next-line no-unused-vars
      openBannerModal: (slug: string) => void
    }
  | undefined
>(undefined)

const ModalProvider = ({ children }: PropsWithChildren) => {
  // const { strings } = useStore()
  const [modal, setModal] = useState<ModalState>({})
  const [preventModal, setPreventModal] = useState(false)
  // const behaviour = useMemo(() => strings?.behaviour, [strings])

  /**
   * Form Modal
   */
  const openFormModal = useCallback(
    () =>
      setModal((modal) => ({
        ...modal,
        form: { ...modal.form, reveal: false, open: true }
      })),
    []
  )
  const handleFormModalClose = useCallback(
    () =>
      setModal((modal) => ({
        ...modal,
        form: { ...modal.form, open: false }
      })),
    []
  )
  const handleFormModalClosed = useCallback(
    () =>
      setModal((modal) => ({
        ...modal,
        form: { ...modal.form, reveal: false }
      })),
    []
  )

  /**
   * Banner Modal
   */
  const openBannerModal = useCallback(
    (slug?: string) =>
      setModal((modal) => ({
        ...modal,
        banner: { ...modal.banner, slug, reveal: false, open: true }
      })),
    []
  )
  const handleBannerModalClose = useCallback(
    () =>
      setModal((modal) => ({
        ...modal,
        banner: { ...modal.banner, open: false }
      })),
    []
  )
  const handleBannerModalClosed = useCallback(
    () =>
      setModal((modal) => ({
        ...modal,
        banner: { ...modal.banner, slug: undefined, reveal: false }
      })),
    []
  )

  /* useEffect(() => {
    if (!behaviour.is_active) return
    const delay = parseInt(behaviour.delay)
    gsap.delayedCall(delay, openFormModal)
  }, [behaviour, openFormModal]) */

  useKey(
    'f',
    () => {
      if (preventModal) return
      openFormModal()
    },
    undefined,
    [preventModal]
  )

  useKey(
    'b',
    () => {
      if (preventModal) return
      openBannerModal()
    },
    undefined,
    [preventModal]
  )

  const contextValue = useMemo(
    () => ({ openBannerModal, setPreventModal }),
    [openBannerModal, setPreventModal]
  )

  return (
    <ModalContext.Provider value={contextValue}>
      {children}

      <Modal
        asChild={true}
        open={modal.banner?.open}
        reveal={modal.banner?.reveal}
        onClose={handleBannerModalClose}
        onClosed={handleBannerModalClosed}
      >
        <BannerModal />
      </Modal>

      <Modal
        asChild={true}
        open={modal.form?.open}
        reveal={modal.form?.reveal}
        onClose={handleFormModalClose}
        onClosed={handleFormModalClosed}
      >
        <FormModal />
      </Modal>
    </ModalContext.Provider>
  )
}

export default ModalProvider
